/*
 *   Copyright (c) 2023
 *   All rights reserved.
 */
import React, { useEffect, useState } from "react";

import TagsInput from "react-tagsinput";
// plugin that creates slider
import Slider from "nouislider";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Switch from "@material-ui/core/Switch";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import * as serviceUser from "../../services/userService";
import * as serviceVehicule from "../../services/vehiculeService";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import { connect } from "react-redux";
import {
  loadParamUserAction,
  updateParamUserForCustomerAction,
} from "action/paramUserAction";
import { createSelector } from "reselect";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import * as notif from "components/Notification/notification";
import { useParams } from "react-router-dom-v5-compat";

const useStyles = makeStyles(styles);

const ParametreUser = (props) => {
  const classes = useStyles();
  const [userSelect, setUserSelect] = useState("");
  const [vehiculeSelect, setVehiculeSelect] = useState("");
  const [paramClientID, setParamClientID] = useState(0);

  const [listVehiculeAPI, setListVehiculeAPI] = useState([]);
  const [listUserAPI, setListUserAPI] = useState([]);

  const [tabDataParametre, setTabDataParametre] = useState([]);
  const [tabDataPermission, setTabDataPermission] = useState([]);

  const [tabReactSwitchElem, setTabReactSwitchElem] = useState(<></>);

  const [
    tabPermissionReactSwitchElem,
    setTabPermissionReactSwitchElem,
  ] = useState(<></>);

  const [openNotif, setOpenNotif] = useState(false);

  const paramURLID = useParams().id;

  useEffect(() => {
    setParamClientID(paramURLID);
  }, []);

  useEffect(() => {
    const dataPayload = {
      email: userSelect,
    };
    if (userSelect !== undefined) {
      if (userSelect !== "") {
        props.loadParamDispatch(dataPayload);
      }
      //console.log('datapayload = ',dataPayload)
    }
  }, [userSelect]);

  useEffect(() => {
    const propsParam = props.loadParamUserFromSaga;

    if (vehiculeSelect !== undefined) {
      if (propsParam !== undefined) {
        if (propsParam.param !== undefined) {
          const data = propsParam.param.filter(
            (data) => data.matricule === vehiculeSelect
          );
          if (data.length > 0) {
            //g("data = ", data[0])
            //console.log("dataparametres = ", data[0].parametres)
            setTabDataParametre(data[0].parametres);
            setTabDataPermission(data[0].permissionVehiculeUser);
          }
        }
      }
    }
  }, [props.loadParamUserFromSaga, vehiculeSelect]);

  useEffect(() => {
    // console.log("tabDataParametre = ", tabDataParametre)
    const mapReturnForSwitch = tabDataParametre.map((param, id) => {
      return (
        <div key={id} className={classes.block}>
          <FormControlLabel
            control={
              <Switch
                id={param.codeParametre + vehiculeSelect}
                name={param.codeParametre}
                // defaultChecked={param.value}
                checked={param.valeur === "true" ? true : false}
                //defaultChecked={param.valeur === "true" ? true : false }
                onChange={handleCheck}
                value={param.codeParametre}
                classes={{
                  switchBase: classes.switchBase,
                  checked: classes.switchChecked,
                  thumb: classes.switchIcon,
                  track: classes.switchBar,
                }}
              />
            }
            classes={{
              label: classes.label,
            }}
            label={param.label}
          />
        </div>
      );
    });
    setTabReactSwitchElem(mapReturnForSwitch);
  }, [tabDataParametre]);

  useEffect(() => {
    // console.log("tabDataParametre = ", tabDataParametre)
    const mapReturnForSwitch = tabDataPermission.map((param, id) => {
      console.log("perm = ", param);
      return (
        <div key={id} className={classes.block}>
          <FormControlLabel
            control={
              <Switch
                id={param.type + vehiculeSelect}
                name={param.type}
                // defaultChecked={param.value}
                checked={param.actif}
                //defaultChecked={param.valeur === "true" ? true : false }
                onChange={handleCheckPermission}
                value={param.type}
                classes={{
                  switchBase: classes.switchBase,
                  checked: classes.switchChecked,
                  thumb: classes.switchIcon,
                  track: classes.switchBar,
                }}
              />
            }
            classes={{
              label: classes.label,
            }}
            label={param.type}
          />
        </div>
      );
    });
    setTabPermissionReactSwitchElem(mapReturnForSwitch);
  }, [tabDataPermission]);

  useEffect(() => {
    if (openNotif === true) {
      if (props.loadParamUserFromSaga.loading === false) {
        let msg;
        let title;

        if (props.loadParamUserFromSaga.isError === true) {
          title = "Echeque Mise a jour parametre";
          msg = "Mise a jours parametre echoué";

          notif.showFailedNotification(title, msg);
        } else {
          title = "Mise a jour";
          msg = "La liste des parametres a ete mis à jour ";

          notif.showSuccessNotification(title, msg);
        }

        setOpenNotif(false);
      }
    }
  }, [props.loadParamUserFromSaga]);

  const handleSelectUser = (event) => {
    setUserSelect(event.target.value);
  };

  const handleSelectVehicule = (event) => {
    setVehiculeSelect(event.target.value);
  };

  const handleButClick = (event) => {
    const dataParametre = {
      matricule: vehiculeSelect,
      email: userSelect,
      parametres: tabDataParametre,
    };
    const dataPermission = {
      emailUser: userSelect,
      vehiculePermission: [
        {
          matricule: vehiculeSelect,
          permissionVehiculeUser: tabDataPermission,
        },
      ],
    };
    const data = {
      dataParametre,
      dataPermission,
    };
    //console.log("data before send = ", data)
    setOpenNotif(true);
    props.updateParamDispatch(data);
  };

  const handleCheck = (event) => {
    const copyTabParam = [...tabDataParametre];
    const idCol = copyTabParam.findIndex(
      (obj) => obj.codeParametre === event.target.value
    );
    copyTabParam[idCol].valeur =
      event.target.checked === true ? "true" : "false";

    //console.log("tabDataParametre", tabDataParametre)
    //console.log("copyTabParam", copyTabParam)

    setTabDataParametre(copyTabParam);
  };

  const handleCheckPermission = (event) => {
    const copyTabParam = [...tabDataPermission];
    const idCol = copyTabParam.findIndex(
      (obj) => obj.type === event.target.value
    );

    copyTabParam[idCol].actif = event.target.checked; // === true ? "true" : "false";
    console.log("copyTabParam = ", copyTabParam);
    //console.log("tabDataParametre", tabDataParametre)
    //console.log("copyTabParam", copyTabParam)

    setTabDataPermission(copyTabParam);
  };

  //console.log("loadVehicule = ", loadVehiculeSelectItem)

  useEffect(() => {
    const data = {
      client: {
        identifiantClient: paramClientID,
      },
    };
    if (paramClientID > 0) {
      serviceVehicule.getListVehicule(data).then((res) => {
        const selectVehiculeLoc = res.map((vehicule, index) => {
          if (index === 0) {
            setVehiculeSelect(vehicule.numeroImmatriculation);
          }
          return (
            <MenuItem
              key={index}
              classes={{
                root: classes.selectMenuItem,
                selected: classes.selectMenuItemSelected,
              }}
              value={vehicule.numeroImmatriculation}
            >
              {vehicule.numeroImmatriculation +
                " ( " +
                vehicule.marque +
                " " +
                vehicule.modele +
                " )"}
            </MenuItem>
          );
        });
        setListVehiculeAPI(selectVehiculeLoc);
      });
    }
  }, [paramClientID]);

  useEffect(() => {
    const data = {
      client: {
        identifiantClient: paramClientID,
      },
    };
    if (paramClientID > 0) {
      serviceUser.getListUserByCustomer(data).then((res) => {
        const selectUserLoc = res.map((user, index) => {
          if (index == 0) {
            setUserSelect(user.email);
          }
          return (
            <MenuItem
              key={index}
              classes={{
                root: classes.selectMenuItem,
                selected: classes.selectMenuItemSelected,
              }}
              value={user.email}
            >
              {user.nom + " " + user.prenom + " ( " + user.email + " )"}
            </MenuItem>
          );
        });
        setListUserAPI(selectUserLoc);
      });
    }
  }, [paramClientID]);

  return (
    <div>
      <GridContainer>
        <GridItem md={6}>
          <Card>
            <CardHeader color="info" icon={false}>
              <h4 className={classes.cardIconTitle}>Utilisateur</h4>
            </CardHeader>
            <CardBody>
              <br />
              <FormControl fullWidth>
                <GridContainer>
                  <GridItem md={6} lg={6}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <Select
                        MenuProps={{
                          className: classes.selectMenu,
                        }}
                        classes={{
                          select: classes.select,
                        }}
                        value={userSelect}
                        onChange={handleSelectUser}
                        inputProps={{
                          name: "selectUser",
                          id: "selectUser",
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classes.selectMenuItem,
                          }}
                        >
                          Utilisateur
                        </MenuItem>

                        {listUserAPI}
                      </Select>
                    </FormControl>
                  </GridItem>
                </GridContainer>
              </FormControl>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem md={6}>
          <Card>
            <CardHeader color="info" icon={false}>
              <h4 className={classes.cardIconTitle}>Vehicule</h4>
            </CardHeader>
            <CardBody>
              <br />
              <FormControl fullWidth>
                <GridContainer>
                  <GridItem md={6} lg={6}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <Select
                        MenuProps={{
                          className: classes.selectMenu,
                        }}
                        classes={{
                          select: classes.select,
                        }}
                        value={vehiculeSelect}
                        onChange={handleSelectVehicule}
                        inputProps={{
                          name: "selectVehicule",
                          id: "selectVehicule",
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classes.selectMenuItem,
                          }}
                        >
                          Vehicule
                        </MenuItem>
                        {listVehiculeAPI}
                      </Select>
                    </FormControl>
                  </GridItem>
                </GridContainer>
              </FormControl>
            </CardBody>
          </Card>
        </GridItem>

        <GridContainer>
          <GridItem xs={6} sm={6} md={6}>
            <Card>
              <CardBody>
                <br />
                <br />
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <legend>Parametres</legend>
                    {tabReactSwitchElem}
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={6} sm={6} md={6}>
            <Card>
              <CardBody>
                <br />
                <br />
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <legend>Permission</legend>
                    {tabPermissionReactSwitchElem}
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </GridContainer>

      <CardFooter className={classes.justifyContentCenter}>
        <Button color="info" onClick={handleButClick}>
          Validate Inputs
        </Button>
      </CardFooter>
    </div>
  );
};

const getParamUser = (state) => state.paramUser;
export const getParamUserState = createSelector(
  [getParamUser],
  (paramUser) => paramUser
);

const mapStateToProps = (state) => {
  console.log("state param", state.paramUser);
  return {
    //loadParamUserFromSaga : state.paramUser
    loadParamUserFromSaga: getParamUserState(state),
  };
};

const mapsDispatchToProps = (dispatch) => {
  return {
    loadParamDispatch: (data) => {
      dispatch(loadParamUserAction(data));
    },
    updateParamDispatch: (data) => {
      dispatch(updateParamUserForCustomerAction(data));
    },
  };
};

export default connect(mapStateToProps, mapsDispatchToProps)(ParametreUser);
